import MappSDK from '@atino/mapp-js-sdk';
const sdk = new MappSDK({
    host: location.origin,
    local: false,
});
export default sdk;
